import { z } from "zod";

/** Lista oficial dos 27 estados + DF — valores usados na prop croState. */
export const BRAZILIAN_STATES = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO",
  "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI",
  "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO",
] as const;

export const brazilianStateSchema = z.enum(BRAZILIAN_STATES);
export type BrazilianState = z.infer<typeof brazilianStateSchema>;

/** Status de verificacao do CRO — alinhado com enum Prisma. */
export const croStatusSchema = z.enum(["PENDING", "VERIFIED", "REJECTED"]);
export type CroStatus = z.infer<typeof croStatusSchema>;

/** CRO: numero de 3-8 digitos + UF. Validacao eh apenas de formato — verificacao real e manual. */
export const croSchema = z.object({
  croNumber: z
    .string()
    .trim()
    .regex(/^\d{3,8}$/, "Numero CRO invalido (3-8 digitos)"),
  croState: brazilianStateSchema,
});

export type CroInput = z.infer<typeof croSchema>;

export const optionalCroSchema = z
  .object({
    croNumber: z
      .string()
      .trim()
      .regex(/^\d{3,8}$/, "Numero CRO invalido")
      .optional()
      .or(z.literal("").transform(() => undefined)),
    croState: brazilianStateSchema.optional(),
  })
  .optional();
